import React, { useEffect, useMemo, useState } from "react";
import Divider from "@material-ui/core/Divider";
import { OrderedProducts } from "./index";
import { fetchOrdersHistoryByOrder } from "../../reducks/users/operations";
import TextDetailForHistory from "../UIkit/TextDetailForHistory";
import { formatOrderDate } from "../../functions/utils/formatting";

// カート(order_id)単位の注文カード。配下の明細(OrderedProducts)がステータスと
// 4日付を持つ。カード見出しには一覧性のために注文日だけを出す。
const OrderHistoryItem = (props) => {
  const { order, updateOrderStatus, orderUid, orderNumber } = props;
  // order はカート単位の見出し(createOrderList の戻り値)で、明細の配列ではない。
  // 明細は下の useEffect で取り直すため、初期値は空配列にしておく
  // (オブジェクトを入れると読み込み中に注文日が一瞬「—」になる)。
  const [products, setProducts] = useState([]);
  const [isLoaded, setIsLoaded] = useState(false);

  const price = "￥" + Number(order.amount).toLocaleString();
  useEffect(() => {
    let isCurrent = true;
    const fetchProducts = async () => {
      const list = await fetchOrdersHistoryByOrder(order.order_id);
      // 取得中に別の注文へ切り替わった場合は捨てる
      if (!isCurrent) return;
      setProducts(Array.isArray(list) ? list : []);
      setIsLoaded(true);
    };
    fetchProducts();
    return () => {
      isCurrent = false;
    };
  }, [order]);

  // 注文日は明細ごとに持つ。通常は同一だが、後から個別に直された場合は「複数」と出す。
  // 読み込みが終わるまでは空欄にする("—"は「未設定」の意味なので、
  // 実際には日付があるのに未設定に見えてしまう)。
  const placedAtLabel = useMemo(() => {
    if (!isLoaded) return "";
    const labels = [
      ...new Set(products.map((item) => formatOrderDate(item.placed_at))),
    ];
    if (labels.length === 0) return "—";
    return labels.length === 1 ? labels[0] : "複数";
  }, [products, isLoaded]);

  return (
    <div>
      <div className="module-spaceer--small" />
      <TextDetailForHistory
        label={"注文ID"}
        value={order.order_id.substring(0, 10)}
      />
      <TextDetailForHistory label={"注文日"} value={placedAtLabel} />
      <TextDetailForHistory label={"注文金額"} value={price} />
      <TextDetailForHistory
        label={"発注部署"}
        value={`${order.order_base_name} ${order.order_department_name}`}
      />
      <TextDetailForHistory
        label={"発注担当者"}
        value={`${order.order_user_dep_name} : ${order.order_user_name}`}
      />
      {order.billing_user_flg === "有" && (
        <TextDetailForHistory
          label={"発注依頼者"}
          value={`${order.billing_user_dep_name} : ${order.billing_user_name}`}
        />
      )}
      {order.billing_company_flg === "有" && (
        <TextDetailForHistory
          label={"仕入先"}
          value={order.billing_company_name}
        />
      )}
      {order.billing_user_flg === "無" &&
        order.billing_company_flg === "無" && (
          <TextDetailForHistory label={"備考"} value={order.remark_on_order} />
        )}
      <TextDetailForHistory
        label={"納入先"}
        value={`${order.delivery_office_name} ${order.delivery_department}`}
      />

      {products.length > 0 && (
        <OrderedProducts
          products={products}
          updateOrderStatus={updateOrderStatus}
          orderUid={orderUid}
          orderNumber={orderNumber}
        />
      )}

      <div className="module-spacer--extra-extra-small" />
      <Divider />
    </div>
  );
};

export default OrderHistoryItem;
